<template>
<!--专家详情-->
  <div class="expert-detail">
    <header-cmp></header-cmp>
    <menu-cmp></menu-cmp>
    <section>
      <div class="page-content">
        <el-breadcrumb separator="/" class="breadcrumb">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/expert' }" v-if="fromPath != '/'">{{ title }}列表</el-breadcrumb-item>
            <el-breadcrumb-item>{{ title }}介绍</el-breadcrumb-item>
        </el-breadcrumb> 
        <div class="expert-main">
            <div class="expert-main-left">
                <img v-if="expert.img" :src="expert.img" class="expert-img" />
                <div class="expert-title">{{ getPainText(expert.name) }}</div>
                <div class="expert-brief">{{ types[expert.type] }}</div>
                <div class="expert-brief">{{ expert.brief }}</div>
                <div class="expert-content article-content" ref="expertContentRef"  v-html="expert.content"></div>
               
            </div>
            <div class="expert-main-right">
                <template v-if="related.length">
                <div class="expert-main-right-title">相关{{ title }}</div>
                <ul class="right-list"  v-if="type == 'expert'">
                    <li v-for="item in related" :key="item.id" class="right-list-item" @click="gotoexpert(item.id)">· {{ item.title || item.name }}</li>
                </ul>
                 <ul class="right-list"  v-else>
                    <li v-for="item in related" :key="item.id" class="right-list-item" @click="gotoexpert(item.id)">· {{ getPainText(item.title) || getPainText(item.name) }}</li>
                </ul>
                </template>
            </div>
        </div>
      </div>
    </section>
    <footer-cmp></footer-cmp>
  </div>
</template>

<script>
  import { delHtmlTag } from "@/utils/index.js";
  import headerCmp from "@/components/common/header.vue"
  import menuCmp from "@/components/common/navMenu.vue"
  import footerCmp from "@/components/common/footer.vue"
  import { getExpertList, getExpertDetail, getLabDetail, getLabList } from "@/api/home/index";
  import "@/assets/style/detail-reset.scss";

  export default{ 
    data(){ 
      return{ 
        id: this.$route.query.id,
        type: this.$route.query.type ||'expert' ,
        title: '专家',
        expert: { },
        related: [],
        fromPath: '',
        types: ['验收专家', '画线师', '专家智库']
      }
    },
    components:{ 
      headerCmp,
      menuCmp,
      footerCmp,
    },
    methods:{ 
        delHtmlTag,
        /*****左侧详情&&右侧列表 */
        getPainText(text){
            if(text){
               text =   delHtmlTag(text);   
               return text.replace(/\s*/g,"");;
            }else{
                return null;
            }
        },
        getContent(){
            const id = this.id;
            if(this.type == 'expert'){  
                getExpertDetail({ id }).then(res=>{
                    this.expert = res.data;
                });
                getExpertList({
                    pageIndex: 1,
                    pageSize: 5,
                }).then(res=>{
                    this.related = res.data.list.filter(i=>i.id != id);
                });
            }else{
                  getLabDetail({ id }).then(res=>{
                    this.expert = res.data;
                });
                getLabList({
                    pageIndex: 1,
                    pageSize: 5,
                }).then(res=>{
                    this.related = res.data.list.filter(i=>i.id != id);
                });
            }
        },
        gotoexpert(id){
            this.$router.push(this.$route.fullPath.replace(/id=(\d)+/, 'id='+id))
        },
    },
    watch: {
        $route() {
            this.id = this.$route.query.id;
            this.getContent()
        }
    },
    mounted(){ 
        this.title = this.type=='lab' ? '实验室' : '专家';
        this.getContent();
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.fromPath = from.path;
        });
    },

  }
</script>

<style lang="scss" scoped>
.expert-detail{
    .breadcrumb{
        color: #666666;
        line-height: 20px;
        margin-top: 20px;
        ::v-deep{
            .el-breadcrumb__inner a:hover, .el-breadcrumb__inner.is-link:hover{
                color: #DA5351;
            }
        }
    }
  .page-content{
    .expert-main{
        margin-top: 40px;
        display: flex;
        justify-content: space-between;
        &-left{
            width: 64.92%;
        }
        .expert-img{
            width: auto;
            max-width: 100%;
            border-radius: 8px;
            margin-bottom: 32px;
            height: 200px;
        }
        .expert-title{
            font-size: 34px;
            font-weight: 500;
            color: #333333;
            line-height: 46px;
        }
        .expert-brief{
            margin: 20px 0;
            color: #333;
            line-height: 20px;
        }
        .expert-content{
            white-space: pre-line;
        //     color: #454545;
        //     font-size: 16px;
        //     line-height: 24px;
        //     ::v-deep{
        //         p{
        //             color: #454545;
        //             font-size: 16px;
        //             line-height: 24px;
        //             text-indent: 2em;    
        //             word-break: break-all;
        //             white-space: normal;
        //         }
        //         strong{
        //             font-size: 18px;
        //             font-weight: 500;
        //             line-height: 32px;
        //         }
        //         img{
        //             max-width: 100%;
        //         }
        //         p>img{
        //             margin-left: -2em;
        //         }
        //     }
        }
    }
    .expert-main-right{
        font-weight: 500;
        width: 31.67%;
        &-title{
            font-size: 24px;
            color: #DA5351;
            line-height: 33px;
            margin-bottom: 18px;
        }
        .right-list{
            font-size: 16px;
            color: #333333;
            line-height: 26px;
            &-item{
                cursor: pointer;
                margin-bottom: 16px;
            }
        }
    }
  }
}

@media screen and (max-width:960px){
    .expert-detail{
        .header{
            margin-bottom: .16rem;
        }
        .page-content{
            .breadcrumb{
                display: none;
            }
            .expert-main{
                padding-top: .20rem;
                flex-wrap: wrap;
                &-left, &-right{
                    width: 100%;
                }

                .expert-img{
                    margin-bottom: .32rem;
                    height: 2rem;
                }
                .expert-title{
                    font-size: .24rem;
                    line-height: .30rem;
                }
                .expert-brief{
                    font-size: .12rem;
                    line-height: .14rem;
                }
                // .expert-content{
                //     color: #454545;
                //     font-size: 16px;
                //     line-height: 24px;
                //     ::v-deep{
                //         p{
                //             font-size: .16rem;
                //             line-height: 1.5;
                //         }
                //         strong{
                //             font-size: .18rem;
                //             line-height: .32rem;
                //         }
                //     }
                // }
               
                .expert-main-right{
                    margin-top: .24rem;
                    &-title{
                        font-size: .18rem;
                        color: #333333;
                        line-height: .24rem;
                        padding-bottom: .12rem;
                        border-bottom: 1px solid #F1F1F1;
                    }
                    .right-list{
                        font-size: .14rem;
                        font-weight: 400;
                        color: #454545;
                        line-height: .20rem;
                    }
                }
            }
        }
    }
}
</style>